<template>
  <LazyModal
    :is-visible="showLegacyBrowserWarning"
    no-cancel
    :tracking="{
      topicKey: 'legacy-browser-warning',
    }"
    @confirm="showLegacyBrowserWarning = false"
  >
    <template #headline>
      {{ $t('restriction.legacybrowser.title') }}
    </template>
    <article class="flex flex-col gap-200">
      <p>
        {{ $t('restriction.legacybrowser.text.intro') }}
      </p>
      <p>
        <i18n-t
          v-if="isIos"
          keypath="restriction.legacybrowser.text.hint.ios"
          tag="span"
        >
          <template #path>
            <b class="paragraph-bold">
              {{ $t('restriction.legacybrowser.text.hint.macos.path') }}
            </b>
          </template>
        </i18n-t>
        <i18n-t
          v-else-if="isMacOS"
          keypath="restriction.legacybrowser.text.hint.macos"
          tag="span"
        >
          <template #path>
            <b class="paragraph-bold">
              {{ $t('restriction.legacybrowser.text.hint.macos.path') }}
            </b>
          </template>
        </i18n-t>
        <template v-else-if="isAndroid">
          {{ $t('restriction.legacybrowser.text.hint.android') }}
        </template>
        <template v-else-if="isMobile">
          {{ $t('restriction.legacybrowser.text.hint.mobile') }}
        </template>
        <template v-else-if="isDesktop">
          {{ $t('restriction.legacybrowser.text.hint.desktop') }}
        </template>
      </p>
      <p>
        {{ $t('restriction.legacybrowser.text.outro') }}
      </p>
    </article>
    <template #confirm>
      {{ $t('restriction.legacybrowser.cta') }}
    </template>
  </LazyModal>
</template>

<script lang="ts" setup>
import { addDays } from 'date-fns'

import { COOKIE_LEGACY_WARNING } from '~/constants/cookies'

const showLegacyBrowserWarning = ref(false)

const { isAndroid, isDesktop, isIos, isMacOS, isMobile } = useDevice()

watchImmediate(
  () => navigator && navigator.userAgent,
  (ua) => {
    if (import.meta.server) return
    if (!ua) return

    const isLegacy = isLegacyBrowser(ua)

    const cookie = useCookie(COOKIE_LEGACY_WARNING, {
      default: () => false,
      expires: addDays(new Date(), 7),
    })

    if (!cookie.value) {
      showLegacyBrowserWarning.value = isLegacy
    }

    cookie.value = isLegacy
  },
)
</script>
